import { styled, Box, Tooltip, TooltipProps, tooltipClasses, Zoom, SxProps } from '@mui/material';

/**
 * Styled Tooltip
 */
export const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        fontSize: 12,
        fontWeight: 'bold',
        boxShadow: theme.shadows[2],
        border: 'solid',
        borderWidth: 'thin',
        backgroundColor: theme.palette.primary.light,
    },
}));

/**
 * ToolTip Props
 */
interface CustomToolTipProps extends Omit<TooltipProps, 'children'> {
    /**
     * The system prop that allows defining system overrides as well as additional CSS styles
     */
    sx?: SxProps;
    children: React.ReactElement;
}

/**
 * Custom ToolTip Component
 */
export const ToolTip = ({ title, placement, sx, children, ...props }: CustomToolTipProps) => (
    <StyledTooltip title={title} placement={placement} TransitionComponent={Zoom} {...props}>
        <Box component="div" sx={sx}>
            {children}
        </Box>
    </StyledTooltip>
);
